import React, { FC, useState, useEffect } from 'react';
import Slider from 'react-slick';
import Heading from '../../atoms/Heading/Heading';

interface AndroidFeaturesProps {
    androidData: any
}

const AndroidFeatures: FC<AndroidFeaturesProps> = ({ androidData }) => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [windowWidth, setWindowWidth] = useState<number>(
        typeof window !== 'undefined' ? window.innerWidth : 1200
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getSliderSettings = () => {
        const baseSettings = {
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 1500,
            arrows: false,
            beforeChange: (_oldIndex: number, newIndex: number) => setActiveSlide(pre => {
                if (newIndex === androidData.AndroidFeaturesList.length - 1) return -1;
                return newIndex;
            }),
            appendDots: (dots: React.ReactNode) => (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                    <ul style={{ display: "flex", justifyContent: "center", gap: "8px", padding: "0px" }}>
                        {dots}
                    </ul>
                </div>
            ),
            customPaging: (i: number) => (
                <div
                    style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        backgroundColor: activeSlide === -1 && i === androidData.AndroidFeaturesList.length - 1 ? "var(--color-primary)" : i === activeSlide ? "var(--color-primary)" : "transparent",
                        border: "2px solid var(--color-primary)",
                        transition: "background-color 0.3s ease",
                        cursor: 'pointer'
                    }}
                />
            ),
        };

        // Responsive settings based on window width
        if (windowWidth < 640) {
            return {
                ...baseSettings,
                slidesToShow: 1,
                slidesToScroll: 1
            };
        } else if (windowWidth < 768) {
            return {
                ...baseSettings,
                slidesToShow: 2,
                slidesToScroll: 1
            };
        } else {
            return {
                ...baseSettings,
                slidesToShow: 3,
                slidesToScroll: 1
            };
        }
    };

    const settings = getSliderSettings();

    return (
        <div className='relative overflow-x-hidden my-8 sm:my-12 md:my-20'>
            <Heading subTitle='Key features of our Android Apps' />
            <div className='mt-8 sm:mt-12 md:mt-20 relative mx-4 md:ml-24 overflow-x-clip'>
                <Slider {...settings} className='mx-0 sm:mx-2 md:mx-4'>
                    {androidData.AndroidFeaturesList.map((service: any, idx: number) => (
                        <div className='px-0 lg:px-4' key={idx} >
                            <div className='relative p-[1px] rounded-xl md:rounded-3xl' style={{ backgroundImage: `linear-gradient(to top left, var(--color-primary)26, ${service.arrowColor})` }}>
                                <div className='bg-blackDark p-4 md:p-4 lg:p-8 pt-10 sm:pt-12 rounded-xl md:rounded-3xl '>
                                    <div className='absolute -top-6 sm:-top-8 w-12 h-12 lg:w-16 lg:h-16 rounded-full flex items-center justify-center' style={{ background: service.arrowColor }} >
                                        <div className='flex items-center justify-center text-white font-black text-base sm:text-xl'>{idx + 1}.
                                        </div>
                                    </div>
                                    <div className='flex flex-col '>
                                        <span className={`text-base sm:text-lg md:text-xl font-medium text-${service.textColor}`}>
                                            <b>{service.title}:</b>
                                        </span>
                                        <span className='text-sm sm:text-base'>
                                            {service.description}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default AndroidFeatures;
